import { render } from "./Add.vue?vue&type=template&id=1ff8c7dd&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=1ff8c7dd&scoped=true&lang=css"

import exportComponent from "D:\\lxq\\nkpcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff8c7dd"]])

export default __exports__